/**
 * Pricing settings API client (BFF: `/api/v1/store/settings/pricing`).
 *
 * Covers pricing/promotion engine settings plus an external-pricing-engine
 * connection test. The external-engine secret is write-only on update.
 */
import { apiClient } from '@/shared/api';
import type {
  PricingSettings,
  TestConnectionResult,
  UpdatePricingSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/pricing';

export const getPricingSettings = async (): Promise<PricingSettings> =>
  (await apiClient.get<PricingSettings>(BASE)).data;

export const updatePricingSettings = async (
  body: UpdatePricingSettingsRequest,
): Promise<PricingSettings> => (await apiClient.put<PricingSettings>(BASE, body)).data;

export const testExternalPricingEngineConnection = async (): Promise<TestConnectionResult> =>
  (await apiClient.post<TestConnectionResult>(`${BASE}/external-engine/test-connection`)).data;
